import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { trackLinkClick } from '@utils/index';

interface TitleProps {
  link: string;
  title: string | React.ReactNode;
  backgroundColor?: string;
  idProp?: string;
  permalink?: string;
  isMainContent?: boolean;
}

const Title = ({
  link,
  title,
  backgroundColor = '#504170',
  idProp,
  permalink,
  isMainContent = false
}: TitleProps) => {
  const extraProps = {} as { id?: string };

  if (idProp) {
    extraProps.id = idProp;
  }

  const renderNonAmazonLink = () => {
    if (!isMainContent && link) {
      return (
        <Link
          href={link}
          variant="h6"
          underline="hover"
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
            trackLinkClick(e, 'blog-deal-title')
          }
          rel="bookmark"
          sx={{
            color: '#fff',
            '&:hover': {
              cursor: 'pointer'
            }
          }}
        >
          <Typography
            variant="h6"
            component={isMainContent ? 'h1' : 'h2'}
            sx={{
              fontSize: { xs: '14px', sm: '1.15rem' }, // subtitle2 size on mobile, h6 size on larger screens
              lineHeight: { xs: '21px', sm: '28px' },
              fontWeight: 400,
              color: '#fff',
              '&:hover': {
                cursor: 'pointer'
              }
            }}
          >
            {title}
          </Typography>
        </Link>
      );
    }

    return (
      <Typography
        variant="h6"
        component={isMainContent ? 'h1' : 'h2'}
        sx={{
          fontSize: { xs: '14px', sm: '1.15rem' }, // subtitle2 size on mobile, h6 size on larger screens
          lineHeight: { xs: '21px', sm: '28px' },
          fontWeight: 400
        }}
      >
        {title}
      </Typography>
    );
  };

  return (
    <Box
      component="header"
      sx={{
        backgroundColor: `${backgroundColor} !important`,
        padding: '12px 16px !important',
        position: 'sticky',
        top: '-1px',
        zIndex: 2,
        color: '#fff',
        boxShadow: `rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px, rgba(0, 0, 0, 0.12) 0px 3px 14px 2px`,
        marginLeft: '-16px !important',
        marginRight: '-16px !important',

        '@media (max-width: 540px)': {
          marginLeft: '-17px !important',
          marginRight: '-17px !important',
          padding: '8px 10px !important'
        }
      }}
      display="block"
      justifyContent="flex-start"
      alignItems="flex-start"
      {...extraProps}
    >
      <Box>
        {permalink && <span id="feed" />}
        {renderNonAmazonLink()}
      </Box>
    </Box>
  );
};

export default Title;
